export default __webpack_public_path__ + "static/media/ThinkAccomodation.15d73ae39432d2b3462b62bb8b542135.webp";